import "./About.module.css";
import MainNavigation from "@/reusable_sections/Header";
import MeetNikiB from "./sections/MeetNikiB";
import ProfessionalMilestones from "./sections/ProfessionalMilestones";
import SiteFooter from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <MainNavigation />
      <MeetNikiB />
      <ProfessionalMilestones />
      <SiteFooter />
    </div>;
}